import { createNextTableContext } from '@core/table';

export const ShopsTableContext = createNextTableContext();
